import { Directive } from '@angular/core';

@Directive({
  selector: '[prepPage],prep-page',
  host: {
    class: 'prep-page'
  }
})
export class PageDirective {

  constructor() { }

}
